import { FC } from "react";

type Props = {
  title: string;
  inputElem: React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >;
  errorMessage?: string;
  help?: string;
};
const InputWithLabel: FC<Props> = ({
  title,
  inputElem,
  errorMessage,
  help = "例: 0.5, 10",
}) => (
  <div className="field">
    <label className="label">{title}</label>
    <div className="field-body">
      <div className="field is-horizontal">
        <div className="control">{inputElem}</div>
        <p
          style={{
            alignSelf: "center",
            fontSize: "1.25rem",
            marginLeft: "1rem",
          }}
        >
          %
        </p>
      </div>
    </div>
    <p className="help" dangerouslySetInnerHTML={{ __html: help }} />
    <p className="help has-text-danger">{errorMessage}</p>
  </div>
);
export default InputWithLabel;
